import Marquee from "react-fast-marquee";

const roles = ["Home & Furniture Delivery", "Man & Van Removals", "Courier & Pallet Delivery", "Construction & Site Deliveries", "Retail & E-commerce", "White Glove Service", "Same-Day Dispatch", "Two-Man Crews"];

export const MarqueeStrip = () => (
  <div className="bg-slate-50 border-y border-slate-200 py-5" data-testid="roles-marquee">
    <Marquee speed={40} gradient gradientColor="#F8FAFC" gradientWidth={80} autoFill>
      {roles.map((r) => (
        <span key={r} className="mx-8 text-sm uppercase tracking-widest text-slate-400 font-semibold flex items-center">
          {r}<span className="ml-16 text-cyan-500">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
